/**
 * Normalize Stripe Price objects to the plan-shaped fields used by subscription UI.
 * Only price_ IDs are supported (no legacy plan_ IDs).
 */

export function isStripePriceId(id) {
  return typeof id === "string" && id.startsWith("price_");
}

export function getSubscriptionCatalogPriceId(record) {
  if (!record || typeof record.id !== "string") {
    return null;
  }
  return isStripePriceId(record.id) ? record.id : null;
}

export function hasActiveSubscriptionPrice(subscriptions, priceId) {
  if (!priceId || !Array.isArray(subscriptions)) {
    return false;
  }
  return subscriptions.some(
    (item) => getSubscriptionCatalogPriceId(item) === priceId
  );
}

export function normalizeStripePrice(price) {
  if (!price || !isStripePriceId(price.id)) {
    return null;
  }

  const isRecurring = price.type === "recurring" || price.recurring != null;
  if (!isRecurring) {
    return null;
  }

  const recurring = price.recurring || {};

  return {
    id: price.id,
    nickname: price.nickname,
    amount: price.unit_amount,
    currency: price.currency,
    interval: recurring.interval,
    interval_count: recurring.interval_count,
    active: price.active,
    metadata: price.metadata || {},
    product: price.product,
  };
}

export function normalizeStripePrices(prices) {
  return (prices || []).map(normalizeStripePrice).filter(Boolean);
}

export function filterNamedSubscriptionPrices(prices) {
  return normalizeStripePrices(prices).filter(
    (price) => price.nickname && price.nickname !== ""
  );
}

export function filterAdvertisementPrices(prices) {
  return normalizeStripePrices(prices).filter(
    (price) => price.metadata.planType === "Advertisement"
  );
}

export async function listStripePrices(stripe, { active } = {}) {
  const params = { limit: 100 };
  if (active !== undefined) {
    params.active = active;
  }
  const page = await stripe.prices.list(params);
  return page.data || [];
}
